export default function PHP_timezone_name_get() {
  return (
    <div>
      <h1>PHP_timezone_name_get</h1>
    </div>
  );
}
